import React, { useCallback } from 'react'
import { toggleCodeBlock } from '@udecode/plate-code-block'
import { useEditorRef, useEditorSelector } from '@udecode/plate-core/react'
import {
    BaseBulletedListPlugin,
    BaseNumberedListPlugin,
    someList,
    unwrapList,
} from '@udecode/plate-list'
import { BoxProps, IconButton } from '@ui'

import { isCodeBlockElement } from '../../utils/helpers'

type Props = {
    background?: BoxProps['background']
}

export const CodeBlockToolbarButton = ({ background }: Props) => {
    const editor = useEditorRef()

    const isCodeBlockActive = useEditorSelector((_editor) => {
        return isCodeBlockElement(editor)
    }, [])

    const onClick = useCallback(() => {
        if (
            someList(editor, BaseNumberedListPlugin.key) ||
            someList(editor, BaseBulletedListPlugin.key)
        ) {
            unwrapList(editor)
        }
        toggleCodeBlock(editor)
    }, [editor])

    return (
        <IconButton
            opaque
            active={isCodeBlockActive}
            icon="codeBlock"
            background={isCodeBlockActive ? 'level3' : background}
            tooltip="Code block"
            tooltipOptions={{ placement: 'vertical', immediate: true }}
            onClick={onClick}
        />
    )
}
